import Vue from 'vue'
import Vuex from 'vuex'
import {Storage} from "@/Services/Storage";
import userModule from "./modules/user-module";
import orderModule from "./modules/orders-module";
import timeModule from "./modules/time-module";
import stockTakeModule from "@/store/modules/stockTakeModule";
import magicModule from "@/store/modules/magic-module";
import numpyModule from "@/store/modules/numpy-modules";
import smartInvoices from "@/store/modules/smartInvoices";
import customerModule from "@/store/modules/customer-module";
import ticketsModule from "@/store/modules/tickets-module";
import ticket_tasks_module from "@/store/modules/ticket_tasks_module";
import ticket_notes_module from "@/store/modules/ticket_notes_module";
import axios from "axios";
import PrintLabel from "@/store/modules/printLabel";

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    loading: false,
    isUpdateAvailable: false,
    currentStore: null,
    stores: [
      {
        id: "021",
        location: "Shekisheki",
      },
      {
        id: "001",
        location: "Kafue",
      },
    ],
    locations: [],
  },
  getters: {
    getLoadingState: (state) => state.loading,
    getUpdateAvailability: (state) => state.isUpdateAvailable,
    getCurrentStore: (state) => state.currentStore,
    getAllStores: (state) => state.stores,
    getAllLocations: (state) => state.locations,
  },
  mutations: {
    setLoadingState: (state, payload) => (state.loading = payload),
    setMobileUser: (state, payload) => Storage.setMobileUser(payload),
    setUpdateAvailability: (state, payload) =>
      (state.isUpdateAvailable = payload),
    setCurrentStore: async (state, payload) => {
      if (payload) await Storage.setCurrentStore(payload);
      else payload = await Storage.getCurrentStore();
      state.currentStore = payload;
    },
    setLocations: (state, payload) => (state.locations = payload),
  },
  actions: {
    syncData: (context, includeOrders = true) => {
      $utils.showLoading();
      let methods = [
        context.dispatch(`getAllUsers`),
        context.dispatch(`getAllLocations`),
      ];
      if (includeOrders) {
        methods.push(context.dispatch(`getOrdersByCurrentTab`));
      }
      return Promise.all(methods).finally(() => $utils.hideLoading());
    },

    getAllLocations: (context) => {
      return axios
        .get(wareHouseTomcatApiC + `location`)
        .then(({ data }) => context.commit(`setLocations`, data))
        .catch((err) => errorHandler.tomcatError(err));
    },

    refreshState: (context) => {
      return context.dispatch(`syncData`).then(() => {
        return Promise.all([
          context.commit(`setAllUsers`),
          context.commit(`setCurrentStore`),
          context.commit(`setCurrentUser`),
        ]);
      });
    },

    getDefaults: () => {
      return axios
        .get(wareHouseTomcatApi + `stockTakeItems/getDefaults`)
        .then(({ data }) => data)
        .catch((err) => errorHandler.tomcatError(err));
    },
    getDashboardData: async () => {
      let location = await Storage.getCurrentStore();
      return axios
        .get(
          wareHouseTomcatApi + `reports/dashboard?location=${location.navID}`
        )
        .then(({ data }) => data)
        .catch((err) => errorHandler.tomcatError(err));
    },

    createProduct: (context, payload) => {
      return axios
        .post(wareHouseTomcatApi + `stockTakeItems/createProduct`, payload)
        .catch((err) => errorHandler.tomcatError(err));
    },

    getTransaction: (context, payload) => {
      const url = `https://overflow.pos.co.zm/Lyt-SoftBackOfficeApi/other/${payload}/searchSales`;
      const body = {
        "from": context.rootGetters.getGlobalDateRange.From,
        "to": context.rootGetters.getGlobalDateRange.To,
        "InvNum": "",
        "SaleTotal": null,
        "PaymentType": "",
        "limit": 50,
        "isSmartInvoice": null
      }

      return axios.post(url, body)
          .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
    },

    sendRequest(context, {url, payload, headers = {}, method = 'post'}) {
      const maxRetries = 3;
      let currentRetry = 0;
      if (!payload.localid){
        payload.localid = generateUUID();
      }

      const attemptRequest = () => {
        return axios[method](url, payload, {
          headers: headers || {}
        }).then(({data}) => {
          if (!data.processed) {
            if (currentRetry < maxRetries) {
              currentRetry++;
              console.log(`Attempt ${currentRetry}: Data unprocessed, retrying...`);
              return attemptRequest();
            }

            throw new Error('Data still unprocessed after maximum retries : ' + maxRetries);
          }
          payload.localid = null;
          return data.response;
        }).catch(err => {
          if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
            if (currentRetry < maxRetries) {
              currentRetry++;
              console.log(`Attempt ${currentRetry}: Retrying...`);
              return attemptRequest();
            }
          }
          throw err;
        });
      };
      return attemptRequest()
          .then(response => response)
          .catch(err => errorHandler.tomcatError(err));
    },

    getPreLoginData: (context, isRefresh = false) => {
      return axios.all([
        context.dispatch('getAllUsers'),
        context.dispatch('getAllDebtors'),
        context.dispatch('getAllTicketStatuses'),
        context.dispatch('getAllTicketTypes')
      ]);
    },
  },
  modules: {
    userModule,
    orderModule,
    timeModule,
    stockTakeModule,
    magicModule,
    numpyModule,
    smartInvoices,
    PrintLabel,
    customerModule,
    ticketsModule,
    ticket_tasks_module,
    ticket_notes_module,
      },
});
